import { render, staticRenderFns } from "./accoutDetail.vue?vue&type=template&id=9f06ae6c&scoped=true"
import script from "./accoutDetail.vue?vue&type=script&lang=js"
export * from "./accoutDetail.vue?vue&type=script&lang=js"
import style0 from "./accoutDetail.vue?vue&type=style&index=0&id=9f06ae6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f06ae6c",
  null
  
)

export default component.exports